import { DashboardWidgetType } from 'features/dashboard/types'
import { InsightData } from 'schemas/action/InsightDataSchema'
import { DecoratedWidgetSettingComposingStrategy } from './strategy/widgetSettingComposing/decorator/type'

export const composeDecoratedDrillDownWidgetSetting = (
  strategy: DecoratedWidgetSettingComposingStrategy,
  widgetSetting: DashboardWidgetType,
  insights: InsightData[],
  pivots: InsightData[]
) => {
  const drillDownWidgetSetting = {} as DashboardWidgetType

  const keys = Object.keys(widgetSetting) as Array<keyof DashboardWidgetType>

  keys.forEach((key) => {
    if (widgetSetting[key] != null) {
      // @ts-ignore
      drillDownWidgetSetting[key] = widgetSetting[key]!
    }
  })

  if (!strategy.canBeDrilledDown(widgetSetting)) {
    return drillDownWidgetSetting
  }

  if (strategy.isOverMaxInput(insights)) {
    return drillDownWidgetSetting
  }

  return strategy.composeDrillDownWidgetSetting(drillDownWidgetSetting, insights, pivots)
}

export default composeDecoratedDrillDownWidgetSetting
